import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Load s the data, resetting the grid's filter and state. After the data is loaded, the callback function is called
 */
export class CallbackLoadDataGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param callback The (untyped) payload. Can also be a callback function
  */
  public handle(callback: any): void {
    this.workspace.grid.applyFilter(null, null).then(() => {
      if (callback) {
        callback();
      }
    });
  }
}
